/* build/tpl */
import deps from './deps/omitDeep.js';
import getOmitDeep from './getOmitDeep.js';
export default getOmitDeep(deps);
